import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import HeaderNavbar from '~/math-vault/components/HeaderNavbar'

import ROUTES from '~/shared/constants/routes.const'

import useWindSurfer from '~/games/hooks/useWindSurfer'
import GameWrapper from '~/games/components/GameWrapper'

function WindSurfer(): React.ReactElement {
  const { t } = useTranslation('games')
  const [showTopbar, setShowTopbar] = useState(true)
  const { windSurferURL } = useWindSurfer(setShowTopbar)

  return (
    <GameWrapper>
      <div className="w-screen h-screen">
        {showTopbar && <HeaderNavbar route={ROUTES.GAMES} title={t('windSurfer.gameTitle')} />}
        <iframe className="w-full h-full absolute top-0" id="windSurferIframe" src={windSurferURL} />
      </div>
    </GameWrapper>
  )
}

export default WindSurfer
